const kind_options = [
  { label: "Normalny", value: "normal" },
  { label: "Korekta", value: "correction" },
  { label: "Dodatkowy", value: "additional" },
];

export default kind_options;
